import { useTranslation } from "react-i18next";
import { SolutionGroupContent, SolutionItemContent } from "./types";
import { education } from "./education";
import { government } from "./government";
import { coreinfra } from "./coreinfra";
import { shield } from "./shield";
import { smartLearning } from "./smartLearning";
import { expertcare } from "./expertcare";
import { netwise } from "./netwise";
import { cloudwork } from "./cloudwork";

export type { SolutionGroupContent, SolutionItemContent } from "./types";

// Ordem do menu "Soluções" do header: Educação e Governo, depois as 6 soluções do catálogo.
export const SOLUTION_GROUPS: SolutionGroupContent[] = [
  education,
  government,
  coreinfra,
  shield,
  smartLearning,
  expertcare,
  netwise,
  cloudwork,
];

export const groupPath = (group: SolutionGroupContent) => `/solucoes/${group.slug}`;
export const itemPath = (group: SolutionGroupContent, item: SolutionItemContent) =>
  item.href ?? `/solucoes/${group.slug}/${item.slug}`;

// Os títulos vêm dos locales (são os mesmos do menu); o restante do texto é só em pt-BR.
export function useSolutionTitles() {
  const { t } = useTranslation();
  return {
    groupTitle: (group: SolutionGroupContent): string => t(group.titleKey, group.title),
    itemTitle: (group: SolutionGroupContent, item: SolutionItemContent): string =>
      t(`header.solutions_menu.items.${group.key}.${item.key}`, item.title),
  };
}

export function findSolution(groupSlug?: string, itemSlug?: string) {
  const group = SOLUTION_GROUPS.find((g) => g.slug === groupSlug);
  const item = itemSlug ? group?.items.find((i) => i.slug === itemSlug) : undefined;
  return { group, item };
}
